import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { SiPaypal } from 'react-icons/si';
import './DonateModal.css';

function DonateModal({ open, onClose }) {
    useEffect(() => {
        if (!open) return;
        const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', handleKey);
        return () => document.removeEventListener('keydown', handleKey);
    }, [open, onClose]);

    if (!open) return null;

    return createPortal(
        <div className="donate-overlay" onClick={onClose} onTouchEnd={onClose}>
            <div className="donate-modal" onClick={(e) => e.stopPropagation()} onTouchEnd={(e) => e.stopPropagation()}>
                <button className="donate-close" onClick={onClose}>&times;</button>
                <h2 className="donate-title">Support Spire Wizard</h2>
                <p className="donate-subtitle">This tool is ad-free and always will be. If it's helped you, consider leaving a tip!</p>

                <div className="donate-options">
                    <button
                        className="donate-option paypal"
                        onClick={() => window.open('https://www.paypal.com/donate/?business=2UT9XLXF4CC8L&no_recurring=0&item_name=Maintaining+and+Improving+the+Spire+Wizard&currency_code=USD')}>
                        <SiPaypal className="donate-icon" style={{ color: '#00457C' }} />
                        <div className="donate-option-text">
                            <span className="donate-option-title">PayPal</span>
                            <span className="donate-option-desc">Donate via PayPal</span>
                        </div>
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}

export default DonateModal;
